import { Button } from "@/components/ui/button"
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "@/components/ui/sheet"
import React from 'react';

export enum Side {
    Right = "right",
    Top = "top",
    Bottom = "bottom",
    Left = "left",
}

type CommentsDialogProps = {
    side: Side
    triggerElement?: React.ReactNode,
    children: React.ReactNode
    open?: boolean
    onOpenChange?: (open: boolean) => void
}

export function CommentsDialog({
    side = Side.Right,
    triggerElement,
    children,
    open,
    onOpenChange,
}: CommentsDialogProps) {
    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            {triggerElement ? (
                <SheetTrigger asChild>
                    {triggerElement}
                </SheetTrigger>
            ) : null}
            <SheetContent side={side} className="w-full max-w-screen sm:w-1/2 lg:w-1/3">
                <SheetHeader>
                    <SheetTitle>Members' reactions</SheetTitle>
                </SheetHeader>
                <div className="flex flex-col gap-4 py-4 h-full">
                    {children}
                </div>
            </SheetContent>
        </Sheet>
    )
}
